import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type { LegacyDeviceBatchUsageLimitProps } from 'types/legacyDashboard';

interface SetUsageAlertsReturn {
  success: boolean;
  error?: string;
  data: { preview: boolean; valid_tasks: Array<Object>; jobid: string };
}

const url = `${process.env.VITE_API_ROOT}/devices/batch/usagelimit`;

const useSetUsageAlerts = (deviceIds: Array<DeviceId>) => {
  const callback = useCallback(
    async (usageAlertThreshold: number) => {
      const result: SetUsageAlertsReturn | undefined =
        await postFetcher<LegacyDeviceBatchUsageLimitProps>({
          url,
          body: {
            deviceids: deviceIds,
            datathreshold: usageAlertThreshold,
          },
        });

      return result;
    },
    [deviceIds]
  );

  return callback;
};

export default useSetUsageAlerts;
